import React from 'react';
import { Menu, Drawer, Space, Typography, Tag } from 'antd';
import { 
  HomeOutlined, 
  FileTextOutlined, 
  UserOutlined, 
  AppstoreAddOutlined, 
  ShoppingCartOutlined, 
  DollarOutlined, 
  TeamOutlined,
  PrinterOutlined
} from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const { Title, Text } = Typography;

const Sidebar = ({ isMobile, drawerVisible, onDrawerClose, onMenuClick }) => {
  const location = useLocation();

  // Extract selected key from path (e.g. /dashboard/invoice -> invoice)
  const currentPath = location.pathname.split('/').filter(Boolean);
  const selectedKey = currentPath.length > 1 ? currentPath[1] : 'home';

  const menuItems = (
    <Menu
      mode="inline"
      selectedKeys={[selectedKey]}
      className="sidebar-menu"
      style={{ 
        height: '100%', 
        borderRight: 0, 
        fontSize: '14px',
        background: '#ffffff',
        paddingTop: '12px'
      }}
      onClick={onMenuClick}
      items={[
        {
          key: 'home',
          icon: <HomeOutlined style={{ fontSize: '16px' }} />,
          label: 'Dashboard Overview',
          style: { marginBottom: '6px' }
        },
        {
          type: 'divider',
          style: { margin: '8px 16px' }
        },
        {
          label: 'Sales Management',
          type: 'group',
          children: [
            {
              key: 'invoice',
              icon: <FileTextOutlined style={{ fontSize: '15px' }} />,
              label: 'Create Invoice',
            },
            {
              key: 'customer',
              icon: <UserOutlined style={{ fontSize: '15px' }} />,
              label: 'Customers Directory',
            },
          ],
        },
        {
          type: 'divider',
          style: { margin: '8px 16px' }
        },
        {
          label: 'Inventory',
          type: 'group',
          children: [
            {
              key: 'product',
              icon: <AppstoreAddOutlined style={{ fontSize: '15px' }} />,
              label: 'Products & Stock',
            },
          ],
        },
        {
          type: 'divider',
          style: { margin: '8px 16px' }
        },
        {
          label: 'Purchase Management',
          type: 'group',
          children: [
            {
              key: 'psh',
              icon: <ShoppingCartOutlined style={{ fontSize: '15px' }} />,
              label: 'Create Purchase',
            },
            {
              key: 'addsupplier',
              icon: <TeamOutlined style={{ fontSize: '15px' }} />,
              label: 'Suppliers',
            },
            {
              key: 'purchaseinvoicehistory',
              icon: <PrinterOutlined style={{ fontSize: '15px' }} />,
              label: 'Purchase History',
            },
          ],
        },
        {
          type: 'divider',
          style: { margin: '8px 16px' }
        },
        {
          label: 'Human Resources',
          type: 'group',
          children: [
            {
              key: 'salary',
              icon: <DollarOutlined style={{ fontSize: '15px' }} />,
              label: 'Payroll & Advances',
            },
          ],
        },
      ]}
    />
  );

  const siderHeader = (
    <div style={{ 
      padding: '24px 20px 20px', 
      background: 'linear-gradient(180deg, #0F172A 0%, #1E293B 100%)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    }}>
      <Space align="center" size={14}>
        <div style={{
          width: 44,
          height: 44,
          borderRadius: 12,
          background: 'linear-gradient(135deg, #4F46E5 0%, #6366F1 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#ffffff',
          fontWeight: 800,
          fontSize: '18px',
          boxShadow: '0 4px 14px rgba(79, 70, 229, 0.4)',
          letterSpacing: '-0.5px'
        }}>
          YG
        </div>
        <div>
          <Title level={5} style={{ color: '#F8FAFC', margin: 0, fontSize: '16px', fontWeight: 700, letterSpacing: '-0.3px' }}>
            Yogi Graphics
          </Title>
          <Space size={6} style={{ marginTop: 2 }}>
            <Text style={{ color: '#94A3B8', fontSize: '12px', fontWeight: 500 }}>Business Suite</Text>
            <Tag color="indigo" style={{ fontSize: '10px', lineHeight: '14px', margin: 0, padding: '0 5px', borderRadius: '4px', border: 'none', background: 'rgba(99, 102, 241, 0.2)', color: '#818CF8' }}>v2.0</Tag>
          </Space>
        </div>
      </Space>
    </div>
  );

  if (isMobile) {
    return (
      <Drawer
        title={siderHeader}
        placement="left"
        closable={true}
        onClose={onDrawerClose}
        open={drawerVisible}
        width={280}
        bodyStyle={{ padding: 0 }}
        headerStyle={{ padding: 0, border: 'none' }}
      >
        {menuItems}
      </Drawer>
    );
  }

  return (
    <div
      style={{
        width: 270,
        background: '#ffffff',
        borderRight: '1px solid #E2E8F0',
        boxShadow: '4px 0 20px rgba(15, 23, 42, 0.03)',
        minHeight: '100vh',
        overflow: 'hidden',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {siderHeader}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {menuItems}
      </div>
    </div>
  );
};

export default Sidebar;

